(function () {
  'use strict';

  // ─── DRAG-TO-SCROLL FOR SWATCHES (Desktop Mouse Support) ──────────────────
  // This enables mouse-dragging on the color swatch lists for desktop users
  // using a standard mouse. Works via event delegation for infinite scroll.
  
  var isDown = false;
  var startX;
  var scrollLeft;
  var activeSlider = null;

  document.addEventListener('mousedown', function(e) {
    var slider = e.target.closest('.product-swatches-options__list');
    if (!slider) return;
    
    isDown = true;
    activeSlider = slider;
    slider.style.cursor = 'grabbing';
    slider.style.userSelect = 'none'; // Prevent text selection while dragging
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });

  function stopDragging() {
    if (!activeSlider) return;
    isDown = false;
    activeSlider.style.cursor = 'pointer';
    activeSlider.style.userSelect = '';
    activeSlider = null;
  }

  document.addEventListener('mouseleave', stopDragging);
  document.addEventListener('mouseup', stopDragging);

  document.addEventListener('mousemove', function(e) {
    if (!isDown || !activeSlider) return;
    e.preventDefault();
    var x = e.pageX - activeSlider.offsetLeft;
    var walk = (x - startX) * 2; // Scroll speed multiplier
    activeSlider.scrollLeft = scrollLeft - walk;
  });

})();
